import React from 'react';
import PropTypes from 'prop-types';
import AnswerNode from './answer-node';
import {filterNodeProperties} from '../../../../utilities/filter-node-properties';
import {decimaltoHex} from '../../../../utilities/common';

const getDataFromNode = function(node) {
    const keys = ['id', 'title', 'over_color', 'selected_color', 'x', 'y', 'width', 'height', 'fontstyle',
        'fontcolor', 'answer_spacing', 'zIndex'];
    return filterNodeProperties(node, keys);
};

class AnswersNode extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            ...getDataFromNode(props.node)
        };
    }

    render() {
        const {x, y, width, height, fontstyle, fontcolor, zIndex} = this.state;
        const divStyle = {
            top: `${y}px`,
            left: `${x}px`,
            fontWeight: fontstyle,
            width: `${width}px`,
            height: `${height}px`,
            textAlign: 'left',
            color: (fontcolor ? `#${decimaltoHex(fontcolor)}` : 'inherit'),
        };
        if (zIndex !== null) {
            divStyle['zIndex'] = zIndex;
        }

        return (
            <div className="node answer-node" style={divStyle}>
                <ul>
                    {
                        /* Use "find" if there will not be more than one answer node. */
                        this.props.node.children.map(n => {
                            switch (n.name) {
                                case 'answer_node':
                                    return <AnswerNode onClick={this.props.onAnswerSelected}
                                                       selected={this.props.answersSelected[n.attr.id]}
                                                       key={n.attr.id} node={n}/>;
                                default:
                                    return null;
                            }
                        })
                    }
                </ul>
            </div>
        );
    }
}

AnswersNode.propTypes = {
    node: PropTypes.object.isRequired,
    answersSelected: PropTypes.object.isRequired,
    onAnswerSelected: PropTypes.func.isRequired
};

export default AnswersNode;



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/answers-node.js